﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { APIEntityService } from '../../_services/entity/API-entity';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';

export interface indCategory {
	value: string;
	viewValue: string
}

@Component({
	selector: 'app-common-registration',
	templateUrl: './tmpe-common-registration-01.component.html',
	styleUrls: ['./tmpe-common-registration-01.component.css']
})

export class TMPECommonRegistrationComponent01 implements OnInit {
	entityForm: FormGroup;
	public emailmobotp: boolean = false;
	public emailVerify: boolean = false;
	public mobileVerify: boolean = false;
	public verifyinfo: boolean = false;

	//public othersFlag: boolean = false;
	public modalRef: BsModalRef;

	public selectedpantanno;
	public makeRead;
	public hide = true;

	otpEExp: any;
	otpMExp: any;
	otpEmail: any;
	otpMobile: any;
	public clicked: boolean = false;
	public isDisabled: boolean = false;
	public isReadonly: boolean = false;
	public ishide: boolean = false;
	public disableEotps: boolean = false;
	public disableMotps: boolean = false;

	returnedValue: any;

	indCategories: indCategory[] = [
		{ value: 'G', viewValue: 'Government' },
		{ value: 'P', viewValue: 'Private Ltd Company' },
		{ value: 'S', viewValue: 'SEBI' },
		{ value: 'U', viewValue: 'Public Limited Company' },
		{ value: 'O1', viewValue: 'Individual' },
		{ value: 'O2', viewValue: 'Sole Proprietorship' },
		{ value: 'O3', viewValue: 'Partnership Firm' },
		{ value: 'O4', viewValue: 'Limited Liability Partnership' },
		{ value: 'O5', viewValue: 'Trust, Association, Society, Club' },
		{ value: 'O', viewValue: 'Others' },
	];
	readOnlyFields: boolean;
	readOnlyFieldsDropdown: boolean;
	Entity_Addr: any = "";
	valueOfPoi: string;
	indusCat: string;
	regOperator: any = "Not registered"; 
	creator: any = "tata";

	constructor(private formBuilder: FormBuilder,
		private modalService: BsModalService,
		private router: Router,
		private ls: APILoginService,
		private _route: ActivatedRoute,
		private $modal: $ModalManagerService,
		private evt: $BroadcastManagerService,
		private es: APIEntityService,
		private db: $DBManagerService) { }

	ngOnInit() {
		
		// this.$modal.errorModal({
		// 	title: 'PE/RTM  Registration',
		// 	msg: 'The site is under maintainence. Please try again later' 
		// }) 
		// this.router.navigateByUrl('/')


		this.entityForm = this.formBuilder.group({
			Organization_Cat: ['', [Validators.required]],
			poiType: ['', [Validators.required]],
			Pancard: ['',],
			Entity_Class: ['',],
			E_Org_Name: ['',],
			Registered_emailId: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')]],

			Registered_mob_no: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10)]],
			email_otp: ['', [Validators.required, Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4), Validators.maxLength(4)]],
			mobile_otp: ['', [Validators.required, Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4), Validators.maxLength(4)]],
			create_pwd: ['', [Validators.required, Validators.pattern]],
			confirm_pwd: ['', [Validators.required]]
		},
			{
				validator: MustMatch('create_pwd', 'confirm_pwd')
			})
	}

	hideClick() {
		this.hide = !this.hide;
	}

	public errormsg;
	public TAN = false;
	public PAN = true;
	public Availability = false;
	public selpriv = false;
	public selgov = true;
	public entity_classification;

	InduCategory(ev) {
		if (ev.target.value == "G" || "S") { }
		//this.othersFlag = false;
		//this.entityForm.controls['OtherDocName'].reset() 
		this.emailmobotp = false;
		if (ev.target.value == "O") {
			
		}

		if (ev.target.value == "O") {
		
			this.entityForm.controls['Registered_emailId'].reset()
			this.entityForm.controls['Registered_mob_no'].reset()
			this.entityForm.controls['create_pwd'].reset()
			this.entityForm.controls['confirm_pwd'].reset()
			this.entityForm.controls['email_otp'].reset()
			this.entityForm.controls['mobile_otp'].reset()
			this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)])
			this.errormsg = "Invalid Pan Number";
		}
		if (ev.target.value == "P" || "S" || "U") {
			
			this.entityForm.controls['Registered_emailId'].reset()
			this.entityForm.controls['Registered_mob_no'].reset()
			this.entityForm.controls['create_pwd'].reset()
			this.entityForm.controls['confirm_pwd'].reset()
			this.entityForm.controls['email_otp'].reset()
			this.entityForm.controls['mobile_otp'].reset()
			this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)])
			this.errormsg = "Invalid Pan Number";
			//this.entityForm.controls['OtherDocName'].reset()
		}
		if (ev.target.value == "G") {
			this.indusCat = "G"
		
			this.entityForm.controls['Registered_emailId'].reset()
			this.entityForm.controls['Registered_mob_no'].reset()
			this.entityForm.controls['create_pwd'].reset()
			this.entityForm.controls['confirm_pwd'].reset()
			this.entityForm.controls['email_otp'].reset()
			this.entityForm.controls['mobile_otp'].reset()
			this.$modal.successModal({
				title: 'Government',
				msg: 'Please provide valid supporting documents in case you are registering under Govt'
			})
		}
		else if (ev.target.value == "S") {
			this.$modal.successModal({
				title: 'SEBI',
				msg: 'Please provide valid supporting documents in case you are registering under SEBI'
			})
		}
	}

	poitype(ev) {
		this.valueOfPoi = ev.target.value;
		if (ev.target.value == "TAN") {
			this.valueOfPoi= "TAN"
			this.PAN = false;
			this.TAN = true;
			this.entityForm.controls['Pancard'].reset()
			this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){4}([0-9]{5})([a-zA-Z]){1}?$/)])
			this.entityForm.controls['Registered_emailId'].setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')])
			this.entityForm.controls['Registered_mob_no'].setValidators([Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10)])
		}

		if (ev.target.value == "PAN") {
			this.valueOfPoi = "PAN"
			this.TAN = false;
			this.PAN = true;
			this.entityForm.controls['Pancard'].reset()
			this.entityForm.controls['Pancard'].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)])
			this.entityForm.controls['Registered_emailId'].setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')])
			this.entityForm.controls['Registered_mob_no'].setValidators([Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10)])
		}
	}

	get f() {
		return this.entityForm.controls;
	}
	checkValid() {
		if((this.entityForm.value["poiType"] == null) || (this.entityForm.value["poiType"] == undefined)){
			this.$modal.errorModal({
				title: 'PE/RTM  Registration',
				msg: 'Please select POI Type!' 
			}) 
			return 
		}
		var data={
			"Entity_Class":this.entity_classification,
			"POI": this.entityForm.get("Pancard").value
		}
		//this.Availability = true;
		this.es.checkPOInEclass(data)
			.subscribe(r => {
				if (r.message == "Initiated") { 
					this.$modal.errorModal({
						title: 'PE/RTM  Registration',
						msg: 'You have already initiated request for the selected classification with Entity Ref Number '+r.RefNo  
					}) 
				} 
				// else if (r.message == "TARegistered") {
				// 	this.$modal.errorModal({
				// 		title: 'PE/RTM  Registration',
				// 		msg: 'You have already registered as TA. PE/TM cannot be a TA!'
				// 	})
				// }
				//  else if (r.message == "PETMRegistered") {
				// 	this.$modal.errorModal({
				// 		title: 'PE/RTM  Registration',
				// 		msg: 'You have already registered as PE/TM. PE/TM cannot be a TA!'
				// 	})
				// } 
				else if (r.message == "blacklisted") { 
					this.$modal.errorModal({
						title: 'PE/RTM  Registration',
						msg: 'This POI is blacklisted! Entity ID is '+r.id
					})
				} else if (r.message == "existingTTL") {
					this.$modal.errorModal({
						title: 'PE/RTM  Registration',
						msg: 'You have already registered for this classification with TATA with Entity ID : '+r.id
					}) 
				} else if(r.message =="NewRegistration") { 
					this.readOnlyFields = true;  
					this.readOnlyFieldsDropdown = false;  
					this.Availability = true;
					this.entityForm.controls['poiType'].disable();
					
				} else if(r.message == "existingOther") {
					this.entityForm.controls['Organization_Cat'].setValue(r.etype);
					this.indusCat = r.etype;
					this.regOperator = r.regOptrs;
					this.creator = r.creator;
					this.entityForm.controls['E_Org_Name'].setValue(r.name);
					this.entityForm.controls['Organization_Cat'].disable();
					this.entityForm.controls['poiType'].disable();
					this.readOnlyFields = true;
					this.readOnlyFieldsDropdown = true;
					this.Entity_Addr= r.address
					this.Availability = true;
				}
				else if (r.message == "Paymentawaited") { 
					this.$modal.errorModal({
						title: 'PE/RTM  Registration',
						msg: 'Your PE/TM request has already been approved. Please complete the payment to get it activated with Entity Ref Number '+r.RefNo  
					}) 
				}
			})
	}
	onSubmit() {

		if (this.entityForm.controls['Organization_Cat'].status === "INVALID" || this.entityForm.controls['poiType'].status === "INVALID" || this.entityForm.controls['Registered_emailId'].status === "INVALID" || this.entityForm.controls['Registered_mob_no'].status === "INVALID" || this.entityForm.controls['Pancard'].status === "INVALID") {
			alert("Please fill the mandatory fields");
			return true;
		}
		if(this.valueOfPoi == 'TAN' && this.indusCat != 'G'){
			this.$modal.errorModal({
				title: 'Industry Category',
				msg: 'Government organization only can enter TAN' 
			})
		} else {  
			

			this.entityForm.controls['Organization_Cat'].setValidators([Validators.required])
			this.entityForm.controls['poiType'].setValidators([Validators.required])
			this.entityForm.controls['Registered_emailId'].setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')])
			this.entityForm.controls['Registered_mob_no'].setValidators([Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10)])
			this.verifyinfo = true;
			this.ishide = true;
			this.isReadonly = true;
			this.entityForm.value["Entity_Addr"]= this.Entity_Addr;
			this.entityForm.value["poiType"] = this.valueOfPoi;
			this.entityForm.value["Organization_Cat"] = this.indusCat
			this.entityForm.value["Registered_Operator"] = this.regOperator;
			this.entityForm.value["Entity_Creator"] = this.creator;
			this.emailmobotp = true;
			this.sendEMOTP("both") 
			
		} 
	}

	sendEMOTP(val) {
		var data = {
			"otpFor": val,
			"emailId": this.entityForm.get("Registered_emailId").value,
			"mobileNo": this.entityForm.get("Registered_mob_no").value,
		}
		this.es.sendEMOTP(data)
			.subscribe(r => {
				
				if (data.otpFor == "email") {
					this.otpEmail = atob(r.Email_OTP);
					this.otpEExp = r.Email_OTP_Time + 600000;

				} else if (data.otpFor == "mobile") {
					this.otpMobile = atob(r.Mobile_OTP);
					this.otpMExp = r.Mobile_OTP_Time + 600000;

				} else {
					this.otpEmail = atob(r.Email_OTP);
					this.otpMobile = atob(r.Mobile_OTP);
					this.otpEExp = r.Email_OTP_Time + 600000;
					this.otpMExp = r.Mobile_OTP_Time + 600000;

				}
			})
	}

	verifyEOTP() {
		let eOTP = this.entityForm.get("email_otp").value;
		if (eOTP.length != 4) {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Enter valid OTP'
			})
			return;
		}
		let currenttime = Date.now()
		if (eOTP == this.otpEmail) {
			if (currenttime > this.otpEExp) {
				this.$modal.errorModal({
					title: 'TM/PE Registration',
					msg: 'OTP has expired!'
				})
			} else {
				this.emailVerify = true
				this.clicked = true;
				this.disableEotps = true;
				this.$modal.successModal({
					title: 'TM/PE Registration',
					msg: 'Email OTP verified!'
				})
			}
		} else {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Entered wrong OTP!'
			})
		}
	}

	verifyMOTP() {
		let mOTP = this.entityForm.get("mobile_otp").value;
		if (mOTP.length != 4) {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Enter valid OTP'
			})
			return;
		}
		let currenttime = Date.now()
		if (mOTP == this.otpMobile) {
			if (currenttime > this.otpMExp) {
				this.$modal.errorModal({
					title: 'TM/PE Registration',
					msg: 'OTP has expired!'
				})
			} else {
				this.mobileVerify = true;
				this.isDisabled = true;
				this.disableMotps = true;
				this.$modal.successModal({
					title: 'TM/PE Registration',
					msg: 'Mobile OTP verified!'
				})
			}
		} else {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Entered wrong OTP!'
			})
		}
	}

	urnGenerate() {
		var data = {
			"Entity_Class": this.entityForm.get("Entity_Class").value,
			"poiType": this.valueOfPoi,  
			"Pancard": this.entityForm.get("Pancard").value,
			"Organization_Cat": this.entityForm.get("Organization_Cat").value, 
			"E_Org_Name": this.entityForm.get("E_Org_Name").value,
			"Entity_Addr": this.Entity_Addr, 
			"Entity_Creator": this.creator,
			"Registered_Operator":  this.regOperator,
			"Registered_emailId": this.entityForm.get("Registered_emailId").value,
			"Registered_mob_no": this.entityForm.get("Registered_mob_no").value,
			"email_otp": this.entityForm.get("email_otp").value,
			"mobile_otp": this.entityForm.get("mobile_otp").value,
			"create_pwd": this.entityForm.get("create_pwd").value,
		} 

		
		let password = this.entityForm.get('create_pwd').value;
		let confirmpassword = this.entityForm.get('confirm_pwd').value;
		if (password != confirmpassword) {
			this.$modal.errorModal({
				title: 'TM/PE Registration',
				msg: 'Password and Confirm password should match'
			})

		}
		else if (this.entityForm.invalid) {
			return;
		}
		else {

			this.es.urnGenerate(data)     
				.subscribe(r => {
					if(r.err){
						if (r.message == "Initiated") { 
							this.$modal.errorModal({
								title: 'PE/RTM  Registration',
								msg: 'You have already initiated request for the selected classification with Entity Ref No '+r.RefNo 
							}) 
						} 
						else if (r.message == "blacklisted") { 
							this.$modal.errorModal({
								title: 'PE/RTM  Registration',
								msg: 'This POI is blacklisted! Entity ID is '+r.id
							})
						} else if (r.message == "existingTTL") {
							this.$modal.errorModal({
								title: 'PE/RTM  Registration',
								msg: 'You have already registered for this classification with TATA with Entity ID '+r.id
							}) 
						}
						else if (r.message == "Paymentawaited") { 
							this.$modal.errorModal({
								title: 'PE/RTM  Registration',
								msg: 'Your PE/TM request has already been approved. Please complete the payment to get it activated! '+r.RefNo 
							}) 
						}
						//this.router.navigateByUrl('/')
						return
					}
					else{
					this.modalRef = this.modalService.show(ModalPromptEntityComponent)
					this.modalRef.content.modalDataObj = {
						title: "Principal Entity/Telemarketer /Aggregator registration",
						msg: "Your details are submitted successfully. Would you like to continue and complete your registration now?"
					}

					this.modalRef.content.onClose.subscribe(result => {
						this.returnedValue = result

						if (this.returnedValue == true) {
							this.router.navigateByUrl('/tmpe-common-registration-02;urn=' + r.Entity_Ref_No)
						} else {
							this.$modal.successModal({
								title: 'PE/RTM Registration',
								msg: 'Your unique reference number is ' + r.Entity_Ref_No + '. Please login to the portal with your Unique Reference No. Details sent on registered mail id / number also.'
							})
							this.router.navigateByUrl('/')
						}
					})
				}
				})
		}
	}
}

